

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
//import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { LicenseInfo } from '@mui/x-license-pro';
import { PayloadAction } from '@reduxjs/toolkit';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import 'filepond/dist/filepond.min.css';
import AppBroadcaster from 'front/AppBroadcaster';
import Recaptcha from 'front/Recaptcha';
import WrapGoogleRecaptcha from 'front/recaptchaWrapper';
import React from 'react';
import { createRoot } from 'react-dom/client';
import 'react-multi-carousel/lib/styles.css';
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { setJsonGet } from '../common/api';
import { AppTheme } from '../common/AppTheme';
import { RouteParamContainer, routes } from '../common/routes';
import { deviceSlice } from '../common/store/deviceSlice';
import { appStore } from '../common/store/store';
import { apiJson } from './api';
import GoogleMapApiProvider from './libraries/CLIENT_GoogleMapApiProvider';
import PageVisibilityHandler from './PageVisibilityHandler';

LicenseInfo.setLicenseKey('a8d045b383d62f91c17ce30814a54c3cTz0xMjc4NjQsRT0xODIyMTc1OTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=');


const router = createBrowserRouter(Object.keys(routes).map((route: keyof RouteParamContainer, index: number) => {
    return {
        path: routes[route].path,
        element: routes[route].component,
        loader: async (q) => {
            if (routes[route]?.skipLoader === true) {
                return null;
            }
            const loadedRoutes = appStore.getState().device.loadedRoutes;
            let pathToLoad: string = '';
            if (routes[route]?.loaderPath) {
                pathToLoad = routes[route].loaderPath;
            } else {

                const url = new URL(q.request.url);
                pathToLoad = url.pathname;
            }
            if (loadedRoutes.indexOf(pathToLoad) === -1) {
                // load data cause route not loaded
                appStore.dispatch(deviceSlice.actions.setLoading(true));
                const result: PayloadAction<any> | PayloadAction<any>[] = await apiJson(pathToLoad, 'get', null, { headers: { 'Accept': 'application/json' } });
                appStore.dispatch(deviceSlice.actions.setLoading(false));
                if (Array.isArray(result)) {
                    result.map(appStore.dispatch);
                } else {
                    appStore.dispatch(result);
                }
                appStore.dispatch(deviceSlice.actions.onRoute(pathToLoad));
            } else {
                // route already loaded
            }
            return null;
        }
    };
}));

setJsonGet((url: string) => {
    return apiJson(url, 'get');
});


const container = document.getElementById('coreContainer');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(<AppTheme>
    <Provider store={appStore}>
        <CssBaseline />
        <AppBroadcaster>
            <GoogleMapApiProvider>
                <LocalizationProvider adapterLocale='fr-CA' dateAdapter={AdapterLuxon}>
                    <WrapGoogleRecaptcha>
                        <PageVisibilityHandler>
                            <Recaptcha />
                            <RouterProvider router={router} />
                        </PageVisibilityHandler>
                    </WrapGoogleRecaptcha>
                </LocalizationProvider>
            </GoogleMapApiProvider>
        </AppBroadcaster>
    </Provider>
</AppTheme>);
